var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1965_24354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9591 10.818C23.838 10.908 21.6994 12.062 21.6994 14.628C21.6994 17.596 24.4206 18.646 24.5021 18.672C24.4896 18.736 24.0698 20.11 23.0673 21.51C22.1735 22.742 21.2399 23.972 19.8198 23.972C18.3996 23.972 18.0342 23.182 16.3947 23.182C14.7971 23.182 14.229 23.998 12.93 23.998C11.631 23.998 10.7246 22.858 9.68243 21.458C8.47531 19.814 7.5 17.26 7.5 14.836C7.5 10.948 10.1398 8.886 12.7378 8.886C14.1183 8.886 15.269 9.754 16.1357 9.754C16.9607 9.754 18.2472 8.834 19.8177 8.834C20.4129 8.834 22.5515 8.886 23.9591 10.818ZM19.0721 7.188C19.7216 6.45 20.1811 5.426 20.1811 4.402C20.1811 4.26 20.1685 4.116 20.1414 4C19.0846 4.038 17.8274 4.674 17.0693 5.516C16.4741 6.164 15.9185 7.188 15.9185 8.226C15.9185 8.382 15.9457 8.538 15.9582 8.588C16.0251 8.6 16.1337 8.614 16.2423 8.614C17.1904 8.614 18.3829 8.006 19.0721 7.188Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1965_24354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "translate(7.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.ee809cf8557cef14dcd24704f4b1c71c.svg";
export { ForwardRef as ReactComponent };